import { Action } from 'redux';

import { SortContent } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';

export interface SortContentAction extends Action {
  order: IOrderClause[];
}

export function sortContent(order: IOrderClause[]): SortContentAction {
  return {
    type: SortContent,
    order
  };
}

export const isSortContentAction = isActionFactory<SortContentAction>(SortContent);
